import { render, staticRenderFns } from "./SurveyCreatedView.vue?vue&type=template&id=e12ff830&scoped=true&"
import script from "./SurveyCreatedView.vue?vue&type=script&lang=js&"
export * from "./SurveyCreatedView.vue?vue&type=script&lang=js&"
import style0 from "./SurveyCreatedView.vue?vue&type=style&index=0&id=e12ff830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12ff830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
